if (!customElements.get('free-sample-product-info')) {
    customElements.define(
        'free-sample-product-info',
        class FreeSampleProductInfo extends HTMLElement {
            constructor() {
                super();
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.swatches = this.querySelectorAll('input[type="checkbox"][name="free-sample-swatch"]:not(:disabled)');
                this.swatchesForFilter = this.querySelectorAll('input[type="checkbox"][name="free-sample-swatch"]');
                this.selectedSwatchElements = this.querySelectorAll('input[type="radio"][name="free-sample-swatch-selected"]');
                this.maxSwatchesToAdd = this.selectedSwatchElements?.length || 0;
                
                this.swatches?.forEach(swatch => swatch.addEventListener('click', this.onClickSwatchHandler.bind(this)));

                this.form = this.querySelector('free-sample-product-form form[data-type="add-to-cart-form"]');
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

                this.submitButton = this.form.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector('span');

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');
                
                this.alreadyAddedSample = [];

                this.filterInputs = this.querySelectorAll('input[type="radio"][name="free-swatch-colour-filter"]');
                this.filterInputs?.forEach(filterInput => filterInput.addEventListener('click', this.onClickFilterInputHandler.bind(this)));
                this.filterText = this.querySelector('[data-asset="filter-colour"]');
                this.filterResetButton = this.querySelector('[data-asset="filter-reset"]');
                this.filterResetButton.addEventListener('click', this.onClickResetFilterHandler.bind(this));

                this.errorMessageWrapper = this.querySelector('free-sample-product-form [data-asset="form-error-message-wrapper"]');

                //debouncing
                setTimeout(async() => {
                    const response = await fetch(`${routes.cart_url}.json`, { cache: "no-store" });
                    await this.init(response);
                    const defaultSwatchField = this.form.querySelector('[data-input="default"]');
                    if (defaultSwatchField?.value) {
                        this.alreadyAddedSample.push(defaultSwatchField.value);
                    }

                    const saveButton = document.querySelector('button[name="add"].button--primary');
                    const labelData = document.getElementById('sample-add-to-cart-label');
                    if (saveButton) {
                        if (this.alreadyAddedSample.length > 1) {
                            const span = saveButton.querySelector('span');
                            if (span) {
                                const sampleAddToCartLabel = labelData ? JSON.parse(labelData.textContent).sample_label : '';
                                span.textContent = sampleAddToCartLabel;
                            }
                        } else {
                            const span = saveButton.querySelector('span');
                            if (span) {
                                const sampleAddToCartLabel = labelData ? JSON.parse(labelData.textContent).default_label : '';
                                span.textContent = sampleAddToCartLabel;
                            }
                        }
                    }
                }, 50);
            }

            async init(response) {
                this.swatches?.forEach(swatch => {
                    swatch.checked = false;
                });
                if (response?.ok) {
                    const cart = await response.json();
                    if (cart) {
                        this.swatches?.forEach(swatch => {
                            const isSampleAlreadyAdded = cart?.items?.find(cartItem => cartItem.id == swatch.dataset.id);
                            if (isSampleAlreadyAdded) {
                                this.alreadyAddedSample.push(swatch.dataset.id);
                                swatch.click();
                            }
                        });
                        this.submitButton.removeAttribute('aria-disabled');
                        this.submitButton.classList.remove('loading');
                        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
                    }
                }
            }

            async onSubmitHandler(event) {
                event.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

                const selectedSwatchIds = this.getSelectedSwatchIds();
                if (selectedSwatchIds.length > this.maxSwatchesToAdd) {
                    this.triggerErrorMessage(`You have reached the limit of ${this.maxSwatchesToAdd} swatches.`);
                    this.resetSubmitButtonState();
                    return;
                }

                await this.refreshCartState();
                await this.removeAlreadyAddedSamplesFromCart();

                const formData = new FormData(this.form);
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                await fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
                    setTimeout(() => {
                        const popupModal = document.querySelector('#MainContent [data-asset="free-sample-product-modal"]');
                        popupModal?.remove();

                        const freeSampleButtons = document.querySelectorAll('[data-action="select-samples"]');
                        freeSampleButtons?.forEach((button) => {
                            button?.setAttribute('aria-disabled', false);
                            button?.classList?.remove('loading');
                            button?.querySelector('.loading__spinner')?.classList?.add('hidden');
                        });

                        document.querySelector('body').classList.remove('free-sample-product-modal--active');
                    }, 50);

                    // Swatch Add To Cart Tracking Event
                    if (Shopify && Shopify.analytics) {
                        const variants = [];
                        let productId = 0;
    
                        for (const pair of formData.entries()) {
                            if (pair[0] === 'product-id') productId = pair[1];
                            if (pair[0].includes('items')) variants.push(pair[1]);
                        }
    
                        window.Shopify?.analytics?.publish?.('swatch_added_to_cart', {
                            product_id: productId,
                            variants: variants,
                        });
                    }

                    // Record the viewed product against Klaviyo. No-ops when the
                    // popup is opened without product context (e.g. homepage or a
                    // collection page) — only the PDP case is tracked.
                    window.trackSwatchInterest?.();

                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response,
                        });
                    this.error = false;
                    this.cart.renderContents(response);
                }).catch((e) => {
                    console.error(e);
                }).finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                });
            }

            async refreshCartState() {
                try {
                    const response = await fetch(`${routes.cart_url}.json`, { cache: "no-store" });
                    if (!response?.ok) return;
                    const cart = await response.json();
                    if (!cart) return;

                    const swatchIdSet = this.getSwatchIdSet();
                    this.alreadyAddedSample = [];
                    cart?.items?.forEach(item => {
                        if (swatchIdSet.has(String(item.id))) {
                            this.alreadyAddedSample.push(String(item.id));
                        }
                    });
                } catch (e) {
                    console.error(e);
                }
            }

            async removeAlreadyAddedSamplesFromCart() {
                if (this.alreadyAddedSample.length > 0) {
                    let updates = {};
                    this.alreadyAddedSample.forEach(sample => {
                        updates[sample] = 0;
                    });

                    await fetch(`${routes.cart_update_url}.js`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ updates })
                    }).then((response) => response.json()).then((response) => {
                        if (!response.status) {
                            return;
                        }
                    }).catch((e) => {
                        console.error(e);
                    });
                } else {
                    return;
                }
            }

            getSwatchIdSet() {
                const swatchIds = new Set();
                this.swatchesForFilter?.forEach(swatch => {
                    if (swatch?.dataset?.id) {
                        swatchIds.add(String(swatch.dataset.id));
                    }
                });
                return swatchIds;
            }

            getSelectedSwatchIds() {
                const swatchIdSet = this.getSwatchIdSet();
                const selectedInputs = this.form?.querySelectorAll('input[name^="items["][name$="][id]"]') || [];
                const selected = [];

                selectedInputs.forEach(input => {
                    const value = String(input.value || '');
                    if (swatchIdSet.has(value)) {
                        selected.push(value);
                    }
                });

                return selected;
            }

            resetSubmitButtonState() {
                this.submitButton.setAttribute('aria-disabled', false);
                this.submitButton.classList.remove('loading');
                this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
            }

            onClickFilterInputHandler(event) {
                const filterColourValue = event.currentTarget.value;
                this.swatchesForFilter?.forEach(swatch => {
                    const colourGroups = swatch.dataset.colourGroups?.split(',');
                    if (colourGroups && colourGroups.includes(filterColourValue)) {
                        swatch.closest('.swatch__field').classList.remove('hidden');
                    } else {
                        swatch.closest('.swatch__field').classList.add('hidden');
                    }

                    const swatchGroupHeadElement = swatch.closest('.swatches-group');
                    const visibleSwatchFields = Array.from(swatchGroupHeadElement.querySelectorAll('.swatch__field')).filter(el => !el.classList.contains('valid-variant-false'));
                    const allHaveHiddenClass = visibleSwatchFields.every(element => element.classList.contains('hidden'));
                    if (allHaveHiddenClass) {
                        swatchGroupHeadElement.classList.add('hidden');
                    } else {
                        swatchGroupHeadElement.classList.remove('hidden');
                    }
                });

                this.filterText.textContent = filterColourValue;
                this.filterResetButton?.classList?.add('active');
            }

            onClickResetFilterHandler(event) {
                this.filterText.textContent = "";
                event.currentTarget?.classList?.remove('active');

                this.swatchesForFilter?.forEach(swatch => {
                    swatch.closest('.swatch__field').classList.remove('hidden');
                    swatch.closest('.swatches-group').classList.remove('hidden');
                });

                this.filterInputs?.forEach(filterInput => {
                    filterInput.checked = false;
                });
            }

            onClickSwatchHandler(event) {
                const swatchElement = event.currentTarget;
                if (!swatchElement || !("checked" in swatchElement)) {
                    console.error("Invalid element. Ensure the event is triggered by a checkbox.");
                    return;
                }

                const data = {
                    id: swatchElement.dataset.id,
                    colour: swatchElement.dataset.colour,
                    image: swatchElement.dataset.image
                };


                const addedSwatchElements = Array.from(this.selectedSwatchElements).filter(element => element.parentNode.classList.contains('added')).length;
                let conditionExecuted = false;
                if (swatchElement.checked == false) {
                    const removedSwatch = Array.from(this.selectedSwatchElements).find(element => element.dataset.id == data.id);
                    if (removedSwatch) {
                        this.removeSwatch(removedSwatch);
                    }
                } else {
                    if (addedSwatchElements < this.maxSwatchesToAdd) {
                        this.selectedSwatchElements.forEach(selectedSwatch => {
                            if (!conditionExecuted && !selectedSwatch.parentNode.classList.contains('added')) {
                                this.addSwatch(selectedSwatch, data);
                                conditionExecuted = true;
                            }
                        });
                    } else {
                        swatchElement.checked = false;
                        this.triggerErrorMessage(`You have reached the limit of ${this.maxSwatchesToAdd} swatches.`);
                    }
                }
            }

            addSwatch(swatch, data) {
                const swatchParent = swatch.parentNode;
                if (!swatchParent.classList.contains('added')) {
                    swatchParent.style.backgroundImage = `url(${data.image})`;
                    swatchParent.classList.add('added');
                    swatch.setAttribute('data-id', data.id);
                    swatchParent.insertAdjacentHTML('afterend', `<span>${data.colour}</span>`);

                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `items[${data.id}][id]`;
                    input.value = data.id;
                    this.form.appendChild(input);
                }
            }

            removeSwatch(swatch) {
                if (swatch) {
                    const variantId = swatch.getAttribute('data-id');
                    const swatchParent = swatch.parentNode;
                    swatchParent.style.backgroundImage = '';
                    swatchParent.classList.remove('added');
                    swatch.removeAttribute('data-id');
                    swatchParent?.nextElementSibling?.remove();

                    const input = this.form.querySelector(`input[value="${variantId}"]`);
                    if (input) {
                        input.remove();
                    }
                }
            }

            triggerErrorMessage(message) {
                if (!message || message == "") {
                    return;
                }
                this.errorMessageWrapper.querySelector('[data-asset="form-error-message"]').textContent = message;
                this.errorMessageWrapper.removeAttribute('hidden');

                setTimeout(() => {
                    this.errorMessageWrapper.querySelector('[data-asset="form-error-message"]').textContent = "";
                    this.errorMessageWrapper.setAttribute('hidden', true);
                }, 1500);
            }
        }
    );
}


if (!customElements.get("free-sample-product-remove")) {
    customElements.define(
        "free-sample-product-remove",
        class FreeSampleProductRemove extends HTMLElement {
            constructor() {
                super();
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.addEventListener("click", this.handleRemoveButtonEvent.bind(this));
            }

            handleRemoveButtonEvent(event) {
                event.currentTarget.closest('[data-asset="free-sample-product"]').classList.add('updating');
                const allLoaders = event.currentTarget.closest('[data-asset="free-sample-product"]').querySelectorAll('.loading__spinner:not(.edit)');
                allLoaders?.forEach(loader => {
                    loader.classList.remove('hidden');
                })
                const body = {
                    updates: JSON.parse(this.dataset.items)
                };

                if (this.cart) {
                    body.sections = this.getSectionsToRender().map((section) => section.section);
                    body.sections_url = this.getSectionsUrl();
                    this.cart.setActiveElement(document.activeElement);
                }
                
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(body) }})
                .then((response) => {return response.text()})
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    this.renderSections(parsedState);
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
                });
            }

            getSectionsUrl() {
                if (window.pageNumber) {
                    return `${window.location.pathname}?page=${window.pageNumber}`;
                } else {
                    return `${window.location.pathname}`;
                }
            }

            getSectionsToRender() {
                return [
                    {
                        id: "main-cart-items",
                        section: document.getElementById("main-cart-items")?.dataset?.id,
                        selector: ".js-contents",
                    },
                    {
                        id: "main-cart-footer",
                        section: document.getElementById("main-cart-footer")?.dataset?.id,
                        selector: ".js-contents",
                    },
                    {
                        id: 'cart-icon-bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section',
                    },
                    {
                        id: 'CartDrawer',
                        selector: '#CartDrawer',
                        section: 'cart-drawer',
                    }
                ];
            }

            renderSections(parsedState) {
                this.getSectionsToRender().forEach((section) => {
                    if (!section.section) return;
                    const sectionElement = document.getElementById(section.id);
                    if (
                        sectionElement &&
                        sectionElement.parentElement &&
                        sectionElement.parentElement.classList.contains('drawer')
                    ) {
                        parsedState.items.length > 0
                        ? sectionElement.parentElement.classList.remove('is-empty')
                        : sectionElement.parentElement.classList.add('is-empty');

                        setTimeout(() => {
                            document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
                        });
                    }
                    const elementToReplace =
                        sectionElement && sectionElement.querySelector(section.selector)
                        ? sectionElement.querySelector(section.selector)
                        : sectionElement;
                    if (elementToReplace) {
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                            parsedState.sections[section.section],
                            section.selector
                        );
                    }
                });
            }

            getSectionInnerHTML(html, selector) {
                return new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector(selector).innerHTML;
            }
        }
    );
}

const freeSampleInit = () => {
    const freeSampleProductModalHtml = `
        <div class="free-sample-product-modal" aria-hidden="true" role="dialog" aria-labelledby="modal-title" data-asset="free-sample-product-modal">
            <div class="free-sample-product-modal__content--wrapper" tabindex="-1">
                <button class="modal__close-button" type="button" aria-label="Close" data-close-modal="button">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
                        <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path>
                    </svg>
                </button>
                <div class="modal__body" data-content="free-sample-product-modal">
                    <div class="loader" data-asset="loader">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                    <div>
                </div>
            </div>
        </div>
    `;
    // Event delegation for free sample trigger buttons.
    document.body.addEventListener('click', (e) => {
        const button = e.target.closest('a[data-action="select-samples"], a[href="#swyft-samples"]');
        if (button) {
            onClickFreeSampleButtonHandler.call(button, e);
        }
    });

    function onClickFreeSampleButtonHandler(event) {
        event.preventDefault();
        if (document.body.classList.contains('free-sample-product-modal--active')) {
            return;
        }

        const cartDrawer = this.closest('cart-drawer');

        const clickedButton = this;
        clickedButton?.querySelector('.title')?.classList?.add('hidden');
        setTimeout(() => {
            clickedButton?.setAttribute('aria-disabled', true);
            clickedButton?.classList?.add('loading');
            clickedButton?.querySelector('.loading__spinner')?.classList?.remove('hidden');
        }, 700);
        
        document.querySelector('#MainContent').insertAdjacentHTML('afterbegin', freeSampleProductModalHtml);
        document.querySelector('body').classList.add('free-sample-product-modal--active');
        fetch(`${location.origin}${window.free_sample_product.swatch_box_product_url}?view=swyft-samples`)
        .then((response) => response.text()).then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('free-sample-product-info');
            const parentOfFreeSampleProduct = productElement.parentElement;

            // Swatch Popup Open Tracking Event
            if (Shopify && Shopify.analytics) {
                window.Shopify?.analytics?.publish?.('swatch_popup_opened');
            }
        
            setTimeout(() => {        
                const popupModal = document.querySelector('#MainContent [data-asset="free-sample-product-modal"]');
                popupModal.setAttribute('aria-hidden', 'false');
                popupModal.querySelector('[data-asset="loader"]').remove();
                popupModal.querySelector('[data-content="free-sample-product-modal"]').appendChild(parentOfFreeSampleProduct);
                popupModal.querySelector('[data-close-modal="button"]').addEventListener('click', function() {
                    popupModal.remove();
                    clickedButton?.setAttribute('aria-disabled', false);
                    clickedButton?.classList?.remove('loading');
                    clickedButton?.querySelector('.loading__spinner')?.classList?.add('hidden');
                    setTimeout(() => {
                        clickedButton?.querySelector('.title')?.classList?.remove('hidden');
                    }, 700);
                    document.querySelector('body').classList.remove('free-sample-product-modal--active');
                });
                if (cartDrawer) {
                    cartDrawer.close();
                }
            }, 50);
        });
    }
}
window.freeSampleInit = freeSampleInit;
freeSampleInit();
